import React from 'react'
import { Checkbox, Col, DatePicker, Form, Input, InputNumber } from 'antd'
import { get } from 'lodash'
import { dateVal } from '../../../../modules/Utils'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { VendorsApi } from '../../../../api/Projects/Resources'
import { compose } from 'recompose'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withData from '../../../../elements/Select/withData'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import withSort from '../../../../elements/HOC/withSort'

const { TextArea } = Input
const IDType = compose(
  withSelectFetch({ dropdown: 'license', name: 'type' }),
  withSpinning,
  withSort,
)(CustomSelect)

function DriverForm (props) {
  const { getFieldDecorator } = props.form
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14, offset: 1 },
    },
  }
  const { driver, project } = props
  const { list: vendors, fetching: fetchingVendors } = useFetchList(() =>
    VendorsApi.list(project._id),
  )
  const VendorsSelect = compose(
    withSpinning,
    withData({
      data: vendors,
    }),
  )(CustomSelect)
  return (
    <Form>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Name">
          {getFieldDecorator('driverName', {
            initialValue: get(driver, 'driverName'),
          })(<Input/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Phone">
          {getFieldDecorator('driverPhone', {
            initialValue: get(driver, 'driverPhone'),
          })(<Input/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Vendor Name">
          {getFieldDecorator('vendor._id', {
            initialValue: get(driver, 'vendor._id'),
          })(
            <VendorsSelect
              fetching={fetchingVendors}
              keyAtr={'_id'}
              valueAtr={'name'}
            />,
          )}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Details">
          {getFieldDecorator('details', {
            initialValue: get(driver, 'details'),
          })(<TextArea/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Start date">
          {getFieldDecorator('date.start', {
            initialValue: dateVal(driver, 'date.start'),
          })(<DatePicker style={{ width: '100%' }}/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="End date">
          {getFieldDecorator('date.end', {
            initialValue: dateVal(driver, 'date.end'),
          })(<DatePicker style={{ width: '100%' }}/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Reference No">
          {getFieldDecorator('reference.no', {
            initialValue: get(driver, 'reference.no'),
          })(<Input/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="ID Type">
          {getFieldDecorator('id.type', {
            initialValue: get(driver, 'id.type'),
          })(<IDType/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="ID No">
          {getFieldDecorator('id.no', {
            initialValue: get(driver, 'id.no'),
          })(<Input/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="License No">
          {getFieldDecorator('license.no', {
            initialValue: get(driver, 'license.no'),
          })(<Input/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="License Expiry">
          {getFieldDecorator('license.expiry', {
            initialValue: dateVal(driver, 'license.expiry'),
          })(<DatePicker/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Amount">
          {getFieldDecorator('amount', {
            initialValue: get(driver, 'amount'),
          })(<InputNumber/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Cost Included with Vehicle">
          {getFieldDecorator('withVehicle', {
            initialValue: get(driver, 'withVehicle'),
            valuePropName: 'checked',
          })(<Checkbox/>)}
        </Form.Item>
      </Col>
    </Form>
  )
}

DriverForm.propTypes = {}
DriverForm.defaultProps = {}

export default Form.create()((DriverForm))
